export const text = {
  readOnlyHint: 'Read-only preview of a shared garden',
};
